<template>
  <van-dialog
    class="verify-tips-dialog"
    v-bind="$attrs"
    v-on="$listeners"
    :show-cancel-button="false"
    :show-confirm-button="false"
    get-container="body"
  >
    <div class="custom-body">
      <div class="header">
        <img
          class="mark"
          src="https://static2.sinsam.com/zhibo/static/img/live-h5/agent/coupon_tips.png"
        />
        <p class="title">确定核销吗</p>
      </div>

      <div class="content">
        <div class="item">
          <span class="title">订单业绩归属代理为</span
          ><span class="text"
            >{{ agentVerifyData.followName }}
            {{ agentVerifyData.followId }}</span
          >
        </div>
        <div class="item">
          <span class="title">该客户当前跟进代理为</span
          ><span class="text"
            >{{ agentVerifyData.currentFollowName }}
            {{ agentVerifyData.currentFollowId }}</span
          >
        </div>
      </div>

      <div class="footer">
        <van-button plain class="btn cancel-btn" @click="$emit('input', false)">
          取消
        </van-button>
        <span class="split"></span>
        <van-button
          class="btn confirm-btn"
          @click="$emit('confirm')"
          v-if="!verifyLoading"
          >确认</van-button
        >
        <van-button
          class="btn confirm-btn"
          v-else
          loading
          loading-text="核销中..."
        >
        </van-button>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'VerifyTips',
  props: {
    agentVerifyData: {
      type: Object,
      default: () => {},
    },
    verifyLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.verify-tips-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 300px;
  background: linear-gradient(180deg, #e9efff 0%, #ffffff 50%);
  border-radius: 16px 16px 16px 16px;
  ::v-deep .van-dialog__content {
    width: calc(100% - 48px);
  }
  .custom-body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .header {
      .title {
        margin: -27px 0 10px 0;
        text-align: center;
        font-size: 16px;
        color: #161823;
        font-weight: blod;
      }
    }
    .content {
      width: 100%;
      padding: 16px 12px;
      background: #f0f7fe;
      border-radius: 10px 10px 10px 10px;
      .item {
        padding: 0 0 16px 0;
        margin-bottom: 16px;
        border-bottom: 1px solid #e5f0ff;
        &:last-child {
          border-bottom: 0;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        .title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #60646b;
          display: block;
        }
        .text {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #202124;
          margin-top: 6px;
        }
      }
    }
  }
  img {
    width: 150px;
    height: 144px;
    flex-shrink: 0;
  }
  .footer {
    width: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    .btn {
      height: 50px;
      line-height: 50px;
      width: 50%;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      cursor: pointer;
      border: 0;
    }
    .confirm-btn {
      color: #006cff;
    }
  }
}
</style>
